import { PageBuilder, TrackingEvent } from '@hey-car/intl-seo-hub.page-builder';
import '@hey-car/intl-seo-hub.page-builder/dist/index.css';
import { IPageData } from 'app/utils/kentico';
import { useTrackingPageContext } from 'app/shared/components/PageWrapper/providers/TrackingPageProvider/TrackingPageProvider';
import { WrapperSt } from 'app/containers/KenticoPage/KenticoPage.css';
import { deepReplace } from 'app/utils/deepReplace';

interface IPageBuilderWrapperProps extends IPageData {}

const PageBuilderWrapper = ({
  pageData,
  kenticoProjectId,
}: IPageBuilderWrapperProps) => {
  const { trackAction } = useTrackingPageContext();
  const handleTracking = (event: TrackingEvent) =>
    trackAction(event.event_name, event.properties);
  return (
    <WrapperSt>
      <PageBuilder
        page={deepReplace(pageData)}
        handleTracking={handleTracking}
        projectId={kenticoProjectId}
      />
    </WrapperSt>
  );
};

export default PageBuilderWrapper;
